import { useMutation } from '@tanstack/react-query';
import { eventBookingService } from '../services/eventBooking.service';
import { EventBookingRequest, EventBookingResponse } from '../types/eventBooking';

export const useEventBooking = () => {
  // Removed booked events tracking

  const mutation = useMutation<EventBookingResponse, Error, EventBookingRequest>({
    mutationFn: (bookingData) => eventBookingService.bookEvent(bookingData)
    // Removed onSuccess handler that tracked booked events
  });

  // Always return false for isEventBooked since we're removing booking tracking
  const isEventBooked = (_eventId: string): boolean => {
    return false;
  };

  return {
    bookEvent: mutation.mutate,
    bookEventAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
    isEventBooked, // Always returns false now
  };
};
